import { MutationCache, QueryCache, QueryClient } from '@tanstack/vue-query';
import * as Sentry from '@sentry/vue';

/**
 * One client, shared by every app via `createConsoleApp`. The defaults deliberately reproduce
 * how an app fetched before TanStack Query, so adopting it carries no user-visible behaviour
 * change: no retry, no staleness, no refetch on focus.
 */
export const queryClient = new QueryClient({
  // Every failure is reported once, as a real `Error` rather than a plain object.
  queryCache: new QueryCache({ onError: error => Sentry.captureException(error) }),
  mutationCache: new MutationCache({ onError: error => Sentry.captureException(error) }),
  defaultOptions: {
    queries: {
      retry: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
      gcTime: 5 * 60 * 1000,
    },
  },
});
